export default __webpack_public_path__ + "static/media/arrow-close-menu.5cb0bd47.svg";